import { render, staticRenderFns } from "./phonenumber.vue?vue&type=template&id=3f2a998e&"
import script from "./phonenumber.vue?vue&type=script&lang=js&"
export * from "./phonenumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports